import { Option, some } from '@sapphire/result';
import { createSelector } from '@ngrx/store';

import {
  getUserAccessLevel,
  getUserType,
  hasServiceOperatorAccessLevel,
  isMultiBuyerUser,
} from '../../utils/user-type.helper';
import { authFeature } from '../auth.feature';

const { selectSession } = authFeature;

export const selectLoading = createSelector(
  selectSession,
  ({ loading }) => loading,
);
export const selectError = createSelector(selectSession, ({ error }) => error);
export const selectUser = createSelector(selectSession, ({ user }) => user);
export const selectFailedLoginAttempts = createSelector(
  selectSession,
  ({ failedLoginAttempts }) => failedLoginAttempts,
);
export const selectRememberMe = createSelector(
  selectSession,
  ({ rememberMe }) => rememberMe,
);

export const selectIsAuthenticated = createSelector(
  selectUser,
  (user) => user !== null,
);

export const selectUserType = createSelector(selectUser, (user) =>
  Option.from(user)
    .mapInto((_user) => some(getUserType(_user)))
    .unwrapOr('none'),
);

export const selectIsBuyer = createSelector(
  selectUserType,
  (user) => user === 'buyer',
);

export const selectIsOperator = createSelector(
  selectUserType,
  (user) => user === 'operator',
);

export const selectIsMultiBuyer = createSelector(selectUser, (user) =>
  Option.from(user)
    .mapInto((_user) => some(isMultiBuyerUser(_user)))
    .unwrapOr(false),
);

export const selectUserAccessLevel = createSelector(
  selectUser,
  selectUserType,
  (user, userType) =>
    Option.from(user)
      .mapInto((_user) => some(getUserAccessLevel(_user, userType)))
      .unwrapOr('none'),
);

export const selectHasServiceOperatorAccess = createSelector(
  selectUser,
  selectUserType,
  (user, userType) =>
    Option.from(user)
      .mapInto((_user) => some(hasServiceOperatorAccessLevel(_user, userType)))
      .unwrapOr(false),
);
